import {TaskServizi} from "@commons/mapping/TaskServizi";
import {ObjectFactory} from "@commons/types";
import {merge} from "lodash";

type TipoStampa = 'SCORPORO' | 'ALLEGATO_CEDOLINO' | 'SCORPORO_ANNO' | null;
type OpzioniStampa = 'STANDARD' | 'SOLO_TOTALI' | 'ZIP_PUBBLICAZIONE';
type Ordinamento = 'NOMINATIVO' | ' CODDIP' | ' CODDIP_EXPORT' | ' ID_DIP' |
    'CDIC_NOMINATIVO' | ' CDIC_CODDIP' | ' CDIC_CODDIP_EXPORT' | ' CDIC_ID_DIP' |
    'AZ_UL_DIP_PAGHE' |
    'GRUPPO_01' |
    'GRUPPO_02' |
    'GRUPPO_03' |
    'GRUPPO_04' |
    'GRUPPO_05' |
    'GRUPPO_06' |
    'GRUPPO_07' |
    'GRUPPO_08' |
    'GRUPPO_09' |
    'GRUPPO_10' |
    'GRUPPO_11' |
    'GRUPPO_12' |
    'SOLO_NOMINATIVO' |
    'AZ_DIP_PAGHE';

export interface StampaFineMeseTask extends TaskServizi {
    tipoStampa: TipoStampa,
    opzioni: OpzioniStampa,

    includiVoci: boolean,
    stampaTuttiIGiustificativi: boolean,
    ordinamento: Ordinamento,

    idSplf?: number,
    linkSplf?: string,
}

export class StampaFineMeseTask {
    static factory: ObjectFactory<StampaFineMeseTask> = (json?) => {
        return merge<StampaFineMeseTask, Partial<StampaFineMeseTask> | undefined>({
            idAziendaMaster: null,
            idAzienda: null,
            anno: null,
            mese: null,
            ggIniziale: null,
            ggFinale: null,
            eseguiPer: null,
            idDipSingolo: null,
            agenziaInterinale: null,
            spaccatura: null,
            codiceCDIC: null,
            dataIniziale: null,
            dataFinale: null,
            result: null,
            stato: null,
            URI: null,
            tipoStampa: null,
            opzioni: 'STANDARD',
            includiVoci: false,
            stampaTuttiIGiustificativi: false,
            ordinamento: 'NOMINATIVO',
        }, json);
    }
}